import { getEligibleSurchargeOffers } from 'api/recommendations'

let eligibleSurchargeOfferIds: Set<string> | undefined
let eligibleSurchargeOfferIdsPromise: Promise<Set<string>> | undefined

export function getEligibleSurchargeOfferIds(): Promise<Set<string>> {
  if (eligibleSurchargeOfferIds) {
    return Promise.resolve(eligibleSurchargeOfferIds)
  }

  if (!eligibleSurchargeOfferIdsPromise) {
    eligibleSurchargeOfferIdsPromise = getEligibleSurchargeOffers()
      .then(offerIds => {
        eligibleSurchargeOfferIds = new Set(offerIds)
        return eligibleSurchargeOfferIds
      })
      .catch((error) => {
        eligibleSurchargeOfferIdsPromise = undefined
        throw error
      })
  }

  return eligibleSurchargeOfferIdsPromise
}

export function resetEligibleSurchargeOfferIdsCache(): void {
  eligibleSurchargeOfferIds = undefined
  eligibleSurchargeOfferIdsPromise = undefined
}
